const Messaging = () => {
   return (
      <svg width="22" height="22" fill="none" viewBox="0 0 22 22">
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.8" d="M21.083 4.583v10.084A1.833 1.833 0 0119.25 16.5h-1.833v3.667l-5.5-3.667H11">
         </path>
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.8" d="M15.583 1.833H2.75A1.833 1.833 0 00.917 3.667V11a1.833 1.833 0 001.833 1.833h1.833v4.584L11 12.833h4.583A1.833 1.833 0 0017.417 11V3.667a1.833 1.833 0 00-1.834-1.834z">
         </path>
      </svg>
   )
}

export default Messaging;